module.exports = __webpack_public_path__ + "img/pointD_hand.1bf025f5.png";